import TaskAssignmentComponent from '../TaskAssignmentComponent.vue'

export default [
    {
        path: '/task_approval',
        name: 'Task Approval',
        meta: { layout: 'default' },
        component: TaskAssignmentComponent,
    },
]